import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { LoadablePaint } from '@confluence/loadable';

const QuestionsRouteComponent = LoadablePaint({
	loader: () =>
		import(
			/* webpackChunkName: "loadable-QuestionsRouteComponent" */ './QuestionsRouteComponent.tsx'
		),
});

export const QuestionsRoute = ({ params: { spaceKey } }: RouteMatch) => {
	return <QuestionsRouteComponent spaceKey={spaceKey} />;
};

export const AskQuestionRoute = ({ params: { spaceKey } }: RouteMatch) => {
	return <QuestionsRouteComponent spaceKey={spaceKey} openCreateQuestionModal />;
};

QuestionsRoute.NAVIGATION_PARAMS = ({ params: { spaceKey } }: RouteMatch) => ({
	Screen: {
		screenEvent: {
			name: 'questionsScreen',
		},
		pageState: {
			spaceKey,
		},
	},
	MainLayout: {
		navView: CONTAINER_HOME_ID,
		spaceKey,
	},
});

AskQuestionRoute.NAVIGATION_PARAMS = QuestionsRoute.NAVIGATION_PARAMS;
